<template>
  <div class="switch-day"
       :class="{change_white: theme}">
    <span :class="{day_choosed: daynumber===1}"
          @click="changeNum(1)">今日</span>
    <span :class="{day_choosed: daynumber===2}"
          @click="changeNum(2)">3日</span>
    <span :class="{day_choosed: daynumber===3}"
          @click="changeNum(3)">5日</span>
    <span :class="{day_choosed: daynumber===4}"
          @click="changeNum(4)">10日</span>
  </div>
</template>

<script>
export default {
  props: ['daynumber'],
  data: function() {
    return {
      captical: 1
    };
  },
  mounted: function() {
    // console.log(window.contentType)
    this.captical = this.daynumber;
  },
  methods: {
    changeNum: function(num) {
      this.captical = num;
      this.$emit('update:daynumber', num);
    }
  },
  computed: {
    theme: function() {
      if (window.theme === 'black') {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped>
.switch-day {
  box-sizing: border-box;
  /* width: 120px; */
  display: flex;
  align-items: center;
  font-size: 0;
  cursor: pointer;
  background: #1b1b1b;
}
.switch-day span:first-child {
  border-radius: 2px 0 0 2px;
}
.switch-day span:last-child {
  border-radius: 0 2px 2px 0;
  border-right: 1px solid #3a3a3a;
}
.switch-day span {
  box-sizing: border-box;
  /* display: inline-block; */
  /* width: 30px;
  height: 16px; */
  display: flex;
  width: 30px;
  justify-content: center;
  font-size: 12px;
  text-align: center;
  border: 1px solid #3a3a3a;
  border-right: 0;
  color: white;
}

.day_choosed {
  color: #c5c5c5 !important;
  background: #3a3a3a !important;
}

.change_white {
  background: rgb(90, 90, 90) !important;
}

.change_white .day_choosed {
  background: #b91010 !important;
  color: #fff !important;
}

.change_white span {
  border: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/card/daySwitch.vue